import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const epvApi = AiseaApiFactory.get("enterpriseVessel");
const cApi = AiseaApiFactory.get("constant");

export default {
  async fetchVessels({ commit }, payload) {
    let res = await epvApi.search(payload);
    commit("SET_VESSELS", res.data.vessels);
    commit("SET_PAGING", res.data.pageable);
    return res.data;
  },

  async fetchCountryCode({ commit }) {
    let res = await cApi.fetchCountryCode();
    commit("SET_COUNTRY_CODE", res.data.country_codes);
    return res.data;
  },

  async updateVesselsSortOrder(_nouse, payload){
    let response = await epvApi.updateSortOrder(payload);
    if ( !response || !response.status ) {
      throw response;
    }
  },

  async resetVesselsListState({ commit }) {
    let defaultState = {
      vessels: [],
      pageable: null,
      countryCodes: []
    };
    commit("RESET_STATE", defaultState);
  }
};
